import api from './api';
import type { Pais, TipoCliente, PublicidadeSpot, Ticket } from '../types';

class PublicService {
  /**
   * Get list of countries
   */
  async getCountries(): Promise<Pais[]> {
    const response = await api.get<{
      success: boolean;
      data?: Pais[];
      error?: string;
    }>('/public/paises');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar países');
  }

  /**
   * Get client types
   */
  async getClientTypes(): Promise<TipoCliente[]> {
    const response = await api.get<{
      success: boolean;
      data?: TipoCliente[];
      error?: string;
    }>('/public/tipos-cliente');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar tipos de cliente');
  }

  /**
   * Get registration info (countries and client types)
   */
  async getRegistrationInfo(): Promise<{
    paises: Pais[];
    tiposCliente: TipoCliente[];
  }> {
    const [paises, tiposCliente] = await Promise.all([
      this.getCountries(),
      this.getClientTypes(),
    ]);

    return { paises, tiposCliente };
  }

  /**
   * Get advertising spots
   */
  async getAdvertisingSpots(): Promise<PublicidadeSpot[]> {
    const response = await api.get<{
      success: boolean;
      data?: PublicidadeSpot[];
      error?: string;
    }>('/public/publicidade');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar publicidade');
  }

  /**
   * Get advertising spot by code
   */
  async getAdvertisingByCode(code: string): Promise<PublicidadeSpot[]> {
    const response = await api.get<{
      success: boolean;
      data?: PublicidadeSpot[];
      error?: string;
    }>(`/public/publicidade?codigo=${code}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar publicidade');
  }

  /**
   * Get user tickets
   */
  async getTickets(): Promise<Ticket[]> {
    const response = await api.get<{
      success: boolean;
      data?: Ticket[];
      error?: string;
    }>('/client/tickets');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar bilhetes');
  }

  /**
   * Get ticket details
   */
  async getTicketDetails(ticketId: string): Promise<Ticket> {
    const response = await api.get<{
      success: boolean;
      data?: Ticket;
      error?: string;
    }>(`/client/tickets/${ticketId}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar detalhes do bilhete');
  }
}

export default new PublicService();
